const HS_LOCALE_KEY = 'hs_locale';
const HS_LOCALE_HEADER = 'X-HS-Locale';

const getLocalStorage = (): Storage | undefined => {
  try {
    return window.localStorage;
  } catch (_error) {
    return undefined;
  }
};

export const getHsLocale = (): string | null => {
  try {
    const storage = getLocalStorage();
    return storage ? storage.getItem(HS_LOCALE_KEY) : null;
  } catch (_e) {
    return null;
  }
};

export const setHsLocale = (locale: string): void => {
  const storage = getLocalStorage();
  if (!storage) {
    return;
  }
  try {
    storage.setItem(HS_LOCALE_KEY, locale);
  } catch (_e) {
    try {
      storage.removeItem(HS_LOCALE_KEY);
    } catch (_error) {
      // If we fail to remove, do nothing
    }
  }
};

export const clearHsLocale = (): void => {
  try {
    const storage = getLocalStorage();
    if (storage) {
      storage.removeItem(HS_LOCALE_KEY);
    }
  } catch (_e) {
    // If we fail to remove, do nothing
  }
};

export const persistHsLocaleFromUserInfo = (
  hsLocale: string | null | undefined,
  isFreshRequest: boolean
): void => {
  if (!isFreshRequest) {
    return;
  }

  if (hsLocale) {
    setHsLocale(hsLocale);
  } else {
    clearHsLocale();
  }
};

// NOTE: This logic is mirrored in quick-fetch (which cannot depend on hs-locale-management).
// If you change the header name or how the locale is resolved, update quick-fetch too.
export const getHsLocaleHeader = (): Record<string, string> => {
  const locale = getHsLocale();
  return locale ? { [HS_LOCALE_HEADER]: locale } : {};
};
